import './Slider.scss'
import { BasicSlider } from './basic_slider'

import { BasicSliderProps, SliderProps } from './types'

const Slider: React.FC<SliderProps> = (props) => {
  return (
    <BasicSlider {...(props as BasicSliderProps)}>{props.children}</BasicSlider>
  )
}

export default Slider
